export default __webpack_public_path__ + "static/helveticaneue-bold-25772415b388426d976e0f5362934faf.woff2";